<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_top_wrap">
      <div class="item_warp" v-for="(item, index) in slogans" :key="index">
        <img :src="item.img" loading="lazy" />
        <div>{{ item.title }}</div>
      </div>
    </div>
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap" v-for="(item, index) in routers" :key="index">
          <div class="item_tit">{{ item.title }}</div>
          <div class="item_options">
            <span
              v-for="(rData, i) in item.subRouters"
              :key="`sub${i}`"
              @click="handleToRouter(rData.path)"
              >{{ rData.title }}</span
            >
          </div>
        </div>

        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/juhan_wx.jpg" alt="" loading="lazy" />
            <span style="text-align: center; margin-top: 15px"
              >真卫士-巨航预约云排队</span
            >
          </div>
        </div>
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/juhan_mp.jpg" alt="" loading="lazy" />
            <span style="text-align: center; margin-top: 15px">真卫士-巨航</span>
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <!-- <span>友情链接:</span>
        <a href="http://www.gov.cn/">中华人民共和国中央人民政府</a>
        <a href="http://www.miit.gov.cn/">中华人民共和国工业和信息化部</a>
        <a href="https://www.fmprc.gov.cn/chn/gxh/tyb/">中华人民共和国外交部</a>
        <a href="http://www.cinn.cn/">中国工业新闻网</a>
        <a href="http://www.cena.com.cn/">中国电子信息产业</a>
        <a href="http://www.cio360.net/">中国信息主管网</a>
        <a href="http://www.ccidcom.com/">通信产业网</a>
        <a href="http://www.cstc.org.cn/">中国软件评测中心</a>
        <a href="http://www.chinaeinet.com/">中国工业和信息化</a>
        <a href="http://www.saism.com.cn/">软件和集成电胳</a> -->
        <p>
          Copyright ©2025 {{aboutus.name}} . All Rights Reserved .
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >{{aboutus.beian}}</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routers: [],
      slogans: [],
      aboutus: {}
    }
  },
  created() {
    this.initData()
  },
  methods: {

    handleToRouter(url) {
      this.$router.replace(url)
    },

    initData() {
      const baseUrl = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_PUBLIC_PATH
        : '/'

      fetch(baseUrl + '/home/data.json')
        .then(response => response.json())
        .then(data => {
          let { routers, slogans, aboutus } = data
          this.routers = routers
          this.slogans = slogans
          this.aboutus = aboutus
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_top_wrap {
    margin: 0 auto;
    width: 60%;
    height: 140px;
    // background: url('../../assets/img/call.a455486.png') 0 0 no-repeat;
    // background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    .item_warp {
      width: 100px;
      height: 120px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      line-height: 48px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 80px;
        height: 80px;
        object-fit: fill;
      }
    }
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 140px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300px;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300px;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>